import React, { useEffect } from "react";
import styled from "styled-components";
import Globais from "../../css/Globais";
import seloMulticotas from "../../images/cadastur-selo_Multicotas.jpg";
import { useMediaQuery } from "react-responsive";

const Container = styled.footer`
  width: 100%;
  height: auto;
  background-color: ${Globais.CorVerde};
  display: flex;
  flex-direction: row; /* Empilha os elementos no mobile */
  justify-content: space-between; /* Centraliza no eixo vertical */
  align-items: center; /* Centraliza no eixo horizontal */
  padding: 2rem; /* Padding menor para telas pequenas */
  gap: 1.5rem; /* Espaçamento uniforme entre os elementos */

  @media (max-width: 768px) {
    padding: 5rem; /* Padding maior para telas grandes */
    gap: 0; /* Remove o gap em telas maiores */
  }
`;

const SubContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column; /* Empilha os elementos no mobile */
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    width: 200px; /* Tamanho maior para telas grandes */
    height: 450px;
  }
`;

const H3 = styled.h3`
  color: #fff;
  font-size: 1rem;
  text-align: center; /* Centraliza o texto no mobile */

  a {
    color: #fff;
    text-decoration: none;
  }

  a:hover {
    color: #dcdde1;
  }

  @media (min-width: 768px) {
    text-align: left; /* Alinha o texto à esquerda para telas grandes */
  }
`;

const Imagem = styled.img`
  width: 250px; /* Tamanho reduzido no mobile */
  height: auto; /* Mantém a proporção */
  margin: 0; /* Remove margens desnecessárias */
  z-index: 0;

  @media (max-width: 768px) {
    width: 200px; /* Tamanho maior para telas grandes */
    height: 300px;
  }
`;

export default function ViewFooter() {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  useEffect(() => {
    const sealElement = document.getElementById("ra-verified-seal");
    const script = document.createElement("script");

    if (sealElement && !document.getElementById("ra-embed-verified-seal")) {
      script.type = "text/javascript";
      script.id = "ra-embed-verified-seal";
      script.src = "https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js";
      script.setAttribute(
        "data-id",
        "RFRtN3J0aTA1NkNwSl9lTTp0ZWxsZXMtc29sdWNvZXMtZGUtdGVjbm9sb2dpYS1sdGRh"
      );
      script.setAttribute("data-target", "ra-verified-seal");
      script.setAttribute("data-model", "2");

      sealElement.appendChild(script);
    }

    return () => {
      // Remova o script quando o componente for desmontado
      const existingScript = document.getElementById("ra-embed-verified-seal");
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <>
      {isMobile? (
        <div style={{display: "none"}}></div>
      ): (
        <Container>
          <SubContainer>
            <div style={{ margin: 15 }} id="ra-verified-seal"></div>
            <Imagem src={seloMulticotas} alt={"Cadastur selo Multicotas"} />
            <H3>CNPJ: 33.600.316/0001-73</H3>
          </SubContainer>
          <SubContainer>
            <H3>
              <a href="/politicaprivacidade" target="_blank">
                Política de Privacidade
              </a>
            </H3>
            <H3>
              <a href="/termodeuso" target="_blank">
                Termos de Uso
              </a>
            </H3>
            <H3>
              <a href="/contato" target="_blank">
                Fale conosco
              </a>
            </H3>
          </SubContainer>
        </Container>
      )}
    </>
  );
}
